var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownloadNew(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.467,
    height: 13.151,
    viewBox: "0 0 16.467 13.151",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "download-cloud-svgrepo-com",
    d: "M10.833,11.093v6.093m0,0L8.875,15.154m1.958,2.031,1.958-2.031M6.133,16.17a3.2,3.2,0,0,1-.877-6.256.132.132,0,0,0,.094-.127,4.7,4.7,0,1,1,9.4,0,.079.079,0,0,0,.1.077,3.087,3.087,0,0,1,.688-.077,3.192,3.192,0,0,1,0,6.383",
    transform: "translate(-2.6 -4.6)",
    fill: "none",
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadNew);
export default __webpack_public_path__ + "static/media/download-new.68833b27a15adbba840d823c74d2f141.svg";
export { ForwardRef as ReactComponent };